import React from 'react'
import { Card, CardText, CardBody, } from 'reactstrap'

const ProgramSearchEmpty = ({ message = null }) => <Card>
  <CardBody>
    <CardText>
      { message || "No programs found." }
    </CardText>
  </CardBody>
</Card>

export default React.memo(ProgramSearchEmpty)